import { memo } from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Switch, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isSupervisorSelector } from "appredux/selectors";
import useStreamChatPreference from "hooks/useStreamChatPreference";

const StreamChatSwitch = () => {
  const { t } = useTranslation();
  const isSupervisor = useSelector(isSupervisorSelector);
  const { enabled, setEnabled } = useStreamChatPreference();

  if (!isSupervisor) {
    return null;
  }

  return (
    <div className="flex flex-row flex-nowrap items-center gap-2 leading-none">
      <Switch
        checked={enabled}
        onChange={setEnabled}
        checkedChildren={t("topBar.streamChat.switchLabel")}
        unCheckedChildren={t("topBar.streamChat.switchLabel")}
        className="shrink-0 [&_.ant-switch-inner]:whitespace-nowrap"
      />
      <Tooltip title={t("topBar.streamChat.tooltip")}>
        <span className="inline-flex items-center shrink-0">
          <QuestionCircleOutlined className="text-gray-500 cursor-help text-base leading-none" />
        </span>
      </Tooltip>
    </div>
  );
};

export default memo(StreamChatSwitch);
